import React, { Component } from 'react';
import classNames from 'classnames';
import {
  arrayOf,
  shape,
  string,
  bool,
  number,
} from 'prop-types';
import _ from 'lodash';
import { Heading, Button, Collapsible } from 'components/common';
import SectionInfoItem from './SectionInfoItem';
import './SectionInfoColumn.scss';

class SectionInfoColumn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowMore: false,
    };

    this.toggleIsShowMore = this.toggleIsShowMore.bind(this);
  }

  toggleIsShowMore() {
    this.setState(prevState => ({
      isShowMore: !prevState.isShowMore,
    }));
  }

  render() {
    const {
      infoItems: itemsRaw,
      title,
      titleHiddenOnDesktop,
      toggleLabels,
      showMoreThreshold,
    } = this.props;

    const { isShowMore } = this.state;
    const titleClasses = {
      'section-info-column-title': true,
      'title-hidden-on-desktop': titleHiddenOnDesktop,
    };
    const infoItems = itemsRaw.filter(
      x => x && !_.isEmpty(_.get(x, 'description.shortDescription') || x.value)
    );

    const initialInfoItems = infoItems.slice(0, showMoreThreshold);
    const collapsedInfoItems = infoItems.slice(showMoreThreshold);

    return (infoItems.length > 0) && (
      <div className="section-info-column">
        {title && (
          <div className={classNames(titleClasses)}>
            <Heading as="h3">
              {title}
            </Heading>
          </div>
        )}
        <div className={classNames({
          'section-info-items-wrapper': true,
          'alpha-layer': collapsedInfoItems.length > 0 && !isShowMore,
        })}
        >
          {initialInfoItems.map(infoItem => (
            <SectionInfoItem
              key={infoItem.type.key}
              {...infoItem}
            />
          ))}
          {collapsedInfoItems.length > 0 && (
            <Collapsible isCollapsed={!isShowMore}>
              {collapsedInfoItems.map(infoItem => (
                <SectionInfoItem
                  key={infoItem.type.key}
                  {...infoItem}
                />
              ))}
            </Collapsible>
          )}
        </div>
        {infoItems.length > showMoreThreshold && (
          <div className="show-more-button-wrapper">
            <Button
              text
              rightIconName={isShowMore ? 'chevron_up' : 'chevron_down'}
              onClick={this.toggleIsShowMore}
            >
              {isShowMore ? toggleLabels.showLess : toggleLabels.showMore}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

SectionInfoColumn.defaultProps = {
  infoItems: [],
  title: null,
  titleHiddenOnDesktop: false,
  toggleLabels: {
    showMore: 'Show more',
    showLess: 'Show less',
  },
  showMoreThreshold: 1,
};

SectionInfoColumn.propTypes = {
  infoItems: arrayOf(
    shape({
      value: string.isRequired,
    })
  ),
  title: string,
  titleHiddenOnDesktop: bool,
  toggleLabels: shape({
    showMore: string,
    showLess: string,
  }),
  showMoreThreshold: number,
};

export default SectionInfoColumn;
